/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IGetStockPayload, IShowStocksByProductPayload, IShowStocksByProductResponse, IStockEntity, IStockManagerListEntity, IStocksListResponse, IUpdateStockPayload } from "./stocks.interface";
import { Environment } from "../../../Config/constants";

export class StocksApiRemoteService {
  constructor(private service: AxiosInstance) {}
    
  public update = async ({ id, data }: IUpdateStockPayload): Promise<Result<void>> => {
    try {
        await this.service.put(`/products/${id}`, data, {
            headers: {
              'Content-Type': 'multipart/form-data', 
            },
          });

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: any): Promise<Result<void>> => {
    try {
        await this.service.post(`/stock/product`, data);

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public listManager = async (productId: string): Promise<Result<IStockManagerListEntity>> => {
    try {
        const response = await this.service.get(`/stocks/product/manager/${productId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async ({ productId, ...rest }: IShowStocksByProductPayload): Promise<Result<IShowStocksByProductResponse>> => {
    try {
   
        const response = await this.service.get(`/stocks/product/${productId}`, { params: { ...rest } });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroy = async (stockId: string): Promise<Result<void>> => {
    try {
    
        const response = await this.service.delete(`/stock/product/${stockId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async (payload: IGetStockPayload): Promise<Result<IStocksListResponse>> => {
    try {
    
        const response = await this.service.get(`/stocks/products`, { params: {
          ...payload,
          searchBy: payload?.search || undefined,
          offset: Number(Environment.OFFSET_REGISTERS) || 50,
        } });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
